import { capitalize } from 'lodash';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function CostModeFormatter({ info }) {
  const { value } = getInfo(info)
  if (!value) return '--'
  return capitalize(value)
}
